<div class="form-row">
  <div class="form-group col-md-4">
    <label for="inputEmail4">Effective Date</label>
    <input type="date" name='name' [(ngModel)]='this.fuelPrice.effectiveDate' [class.is-invalid]='!this.fuelPrice.effectiveDate' class="form-control" id="inputEmail4">
  </div>
  <div class="form-group col-md-4">
    <label for="inputEmail4">Price (in pence)</label>
    <input type="number" name='name' [(ngModel)]='this.fuelPrice.price' [class.is-invalid]='!this.fuelPrice.price' class="form-control" id="inputEmail4">
  </div>
  <div class="form-group col-md-4">
    <label for="inputPassword4">Fuel type</label>
    <select class='form-control' [class.is-invalid]='this.fuelPrice.fuelTypeId === -1' (change)='this.fuelPrice.fuelTypeId = +$event.target.value; this.fuelPrice.fuelType.id = this.fuelPrice.fuelTypeId'>
      <option value='-1'>Select a fuel type</option>
      @for (item of this.types; track item) {
        <option [value]='item.id' [selected]='this.fuelPrice.fuelTypeId === item.id'>{{ item.name }}</option>
      }
    </select>
  </div>
</div>
